import { Contract, ethers } from 'ethers';
import MinterV3 from 'contracts/MinterV3.json';
import MinterV3C from 'contracts/MinterV3C.json';
import Zoom from 'contracts/Zoom.json';

let _magnumContract: Contract;
let _curatedContract: Contract;
let _zoomContract: Contract;
// Initialize unauthenticated contracts via singleton to avoid hitting Infura rate limit
(async () => {
  try {
    const provider = new ethers.providers.JsonRpcProvider(
      `https://${process.env.NEXT_PUBLIC_NETWORK}.infura.io/v3/${process.env.NEXT_PUBLIC_INFURA_ID}`
    );
    _magnumContract = await new ethers.Contract(
      process.env.NEXT_PUBLIC_MINTERV3_CONTRACT,
      MinterV3.abi,
      provider
    );
    _curatedContract = await new ethers.Contract(
      process.env.NEXT_PUBLIC_MINTERV3C_CONTRACT,
      MinterV3C.abi,
      provider
    );
    _zoomContract = await new ethers.Contract(
      process.env.NEXT_PUBLIC_ZOOM_CONTRACT,
      Zoom.abi,
      provider
    )
  } catch (e) {}
})();

export const getCuratedContract = () => {
  if (_curatedContract) {
    return _curatedContract;
  } else {
    throw new Error('Failed to get contract, not defined');
  }
};

// Unauthenticated contract for Magnum
export const getMagnumContract = () => {
  if (_magnumContract) {
    return _magnumContract;
  } else {
    throw new Error('Failed to get contracted, not defined');
  }
};

export const getZoomContract = () => {
  if (_zoomContract) {
    return _zoomContract;
  } else {
    throw new Error('Failed to get contracted, not defined');
  }
}